module.exports = "https://la-static.vkplay.ru/promo/newstart/img/devilhunter.2a36d0b5.png";